import React, { Component } from 'react';
import queryString from 'query-string'
import PropTypes from 'prop-types'
import { BeatLoader } from 'react-spinners';
import AppHeader from '../Misc/AppHeader';
import { Link } from 'react-router-dom';
import NotificationSystem from 'react-notification-system';
import { get, getAccessToken } from "../../server/actions";
import Cookies from 'universal-cookie';
import { _addNotificationError, emailPattern } from "../../server/util";
import { domains, catererDomains, districtDomains, BASE_URL_2, ROLES } from "../../server/constants";
import moment from 'moment'
import './login.css';
import Logo from './logo';
var _ = require('lodash');

let loggedUserInfo = { "access": { token: '12343' }, "user": { name: "vikas" } };
let id = '';
class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            userName: "",
            password: "",
            cookies: new Cookies(),
            isCookie: false,
            isSuperAdmin: false,
            parentEmail: '',
            parentRegMsg: '',
            isParentError: false,
            akey: '',
            rkey: '',
            singleLogin: false
        }
        this.isSuperAdmin = this.isSuperAdmin.bind(this);
        this.selfRegParent = this.selfRegParent.bind(this);
    }
    componentWillMount = () => {
        const search = window.location.search.substring(1, window.location.search.length);
        const parsed = queryString.parse(atob(search));
        if (parsed.akey) {
            this.setState({ akey: parsed.akey, rkey: parsed.rkey, singleLogin: true }, () => {
                this.schoolAdminLoginWithSuperKey()
            })
        }
    }

    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem;
        if (this.state.cookies.get('userName')) {
            this.setState({ userName: this.state.cookies.get('userName') });
        }
        this.isSuperAdmin();
    }
    schoolAdminLoginWithSuperKey = () => {
        let url = window.location.host;
        let splitArray = url.split('.');
        const requestOptions = {
            'method': 'get',
            'Authorization': 'Basic ' + btoa('my-trusted-client:secret'),
            'Content-Type': 'application/x-www-form-urlencoded'
        };
        this.setState({ loading: true })
        fetch(`${BASE_URL_2}/mealSchools/search/findBySubdomain?subdomain=${splitArray[0]}&access_token=${this.state.akey}`, requestOptions).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            let isPaymentEnable = data.isPaymentEnabled || false;
            let pri_users = _.filter(data.schoolUsers, function (itm) { return itm.isPrimaryUser === true });
            let isPrimaryAdmin = (pri_users.length > 0) === true ? true : false;
            let stripeAccountId = data.stripeAccountId;
            let stripeAcceptance = data.stripeAcceptance;
            if (data !== null || data !== '') {
                let schoolId = data._links.self.href.split("/").pop();
                fetch(BASE_URL_2 + '/login/' + schoolId + '?loginModule=' + this.getRoleByUrl() + '&currentDate=' + moment().format('YYYY-MM-DD') + '&access_token=' + this.state.akey, requestOptions).then((response) => {
                    if (!response.ok) {
                        throw Error(response.statusText);
                    }
                    return response.json();
                }).then(data => {
                    sessionStorage.setItem('access_token', this.state.akey)
                    sessionStorage.setItem('refresh_token', this.state.rkey)
                    sessionStorage.setItem('SchoolId', schoolId);
                    sessionStorage.setItem('ROLE', 'ROLE_ADMIN');
                    sessionStorage.setItem('loggedInUserInfo', JSON.stringify(data));
                    sessionStorage.setItem('loggedUserName', data.username);
                    sessionStorage.setItem('currency_symbol', data.currencySymbol);
                    sessionStorage.setItem('date_format', data.dateFormat);
                    sessionStorage.setItem('countryCode', data.countryCode);
                    sessionStorage.setItem('pageSize', JSON.stringify(data.pageSize || {}));
                    sessionStorage.setItem('date_format', data.dateFormat);
                    sessionStorage.setItem('ISD_code', data.isdCode);
                    sessionStorage.setItem('phoneValidation', data.phoneValidation || 10);
                    sessionStorage.setItem('donationStatus', data.acceptMealDonation);
                    sessionStorage.setItem('spendingLimit', data.dailySpendingLimit)
                    loggedUserInfo.user = data;
                    let sessionUserInfoData = JSON.parse(sessionStorage.getItem('loggedInUserInfo'))
                    sessionUserInfoData.isPaymentEnable = isPaymentEnable;
                    sessionUserInfoData.isPrimaryAdmin = isPrimaryAdmin;
                    sessionUserInfoData.stripeAccountId = stripeAccountId;
                    sessionUserInfoData.stripeAcceptance = stripeAcceptance;
                    sessionStorage.setItem('loggedInUserInfo', JSON.stringify(sessionUserInfoData));
                    sessionStorage.setItem('schoolYearValue', data.schoolYear)
                    sessionStorage.setItem('activeMonth', data.latestActiveMonth)
                    this.context.router.history.push('/schoolAdmin')
                    this.setState({ loading: false, singleLogin: false })
                }).catch(
                    (error) => {
                        _addNotificationError('Invalid Sub Domain/access token. Please login with username & password.', this)
                        console.log(' response', error)
                        this.setState({ loading: false, singleLogin: false })
                    }
                )
            }
        })
            .catch(
                (error) => {
                    this.setState({ loading: false, singleLogin: false })
                    _addNotificationError('Invalid Sub Domain/access token. Please login with username & password.', this)
                    console.log(' response', error)
                }
            )
    }

    handleUserNameChanged(event) {
        this.setState({ userName: event.target.value });
    }

    handlePasswordChanged(event) {
        this.setState({ password: event.target.value });
    }

    handleParentEmailChanged(event) {
        this.setState({ parentEmail: event.target.value });
    }

    setCookie(event) {
        const target = event.target;
        const value = target.checked;
        if (value) {
            this.state.cookies.set('userName', this.state.userName, { path: '/', maxAge: 31536000 });
        }
    }

    isSuperAdmin() {
        let url = window.location.href;
        //remove www.
        domains.forEach(domain => {
            url = url.replace(domain, '');
        })
        // //remove .com
        let splitArray = url.split('.');
        if (splitArray.length === 1) {//Super Admin or parent
            this.setState({ isSuperAdmin: true });
        }
        else {
            this.setState({ isSuperAdmin: false });
        }
    }

    selfRegParent(event) {
        event.preventDefault();
        if (!emailPattern.test(this.state.parentEmail)) {
            _addNotificationError("You have entered an invalid email address!", this)
            return (false)
        }


        get('/selfRegParent?emailId=' + this.state.parentEmail, false).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
        }).catch(
            (error) => {
                console.log(' response', error)
            }
        );
        this.setState({ parentRegMsg: 'Request submitted successfully. If your email id is registered, you will receive an access link soon.' });
        this.setState({ isParentError: false });
        event.preventDefault();
    }

    getRoleByUrl = () => {
        let url = window.location.href;
        let subdomain = ((window.location.host).split('.') || [])[0] || ''
        domains.forEach(domain => {
            url = url.replace(domain, '');
        });
        districtDomains.forEach(ddomain => {
            url = url.replace(ddomain, '');
        })
        let splitArray = url.split('.');
        if (splitArray.length === 1) {
            if (districtDomains.includes(subdomain + '.')) {
                return ROLES.DISTRICT;
            }
            else if (domains.includes(subdomain + '.')) {
                return ROLES.SUPERADMIN;
            }
            return '';
        } else if (splitArray.length === 2) {
            return ROLES.ADMIN;
        }
        return '';
    }

    onSignInClick = (event) => {
        event.preventDefault();
        let uname = this.state.userName;
        getAccessToken(this.state.userName, this.state.password, this.getRoleByUrl()).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            sessionStorage.setItem('access_token', data.access_token)
            sessionStorage.setItem('refresh_token', data.refresh_token)
            sessionStorage.setItem('expires_in', (data.expires_in) * 1000 + 1)
            loggedUserInfo.access = data;
            let url = window.location.href;
            domains.forEach(domain => {
                url = url.replace(domain, '');
            });
            catererDomains.forEach(cdomain => {
                url = url.replace(cdomain, '');
            })
            districtDomains.forEach(ddomain => {
                url = url.replace(ddomain, '');
            })
            let splitArray = url.split('.');
            if (splitArray.length === 1) {//Super Admin or parent
                if (splitArray[0]) {
                    sessionStorage.setItem('isSAdmin', 'true');
                    sessionStorage.setItem('isAdmin', 'false');
                    get(`/login/${0}?loginModule=${this.getRoleByUrl()}&currentDate=${moment().format('YYYY-MM-DD')}&access_token=`).then((response) => {
                        if (!response.ok) {
                            throw Error(response.statusText);
                        }
                        console.log('response', response);
                        return response.json();
                    }).then(data => {
                        sessionStorage.setItem('loggedInUserDetails', JSON.stringify(data));
                        sessionStorage.setItem('loggedInUserInfo', data.username);
                        sessionStorage.setItem('ROLE', data.role);
                        loggedUserInfo.user = data;
                        console.log('login user', loggedUserInfo);
                        this.props.setUserInfo(loggedUserInfo);
                        if (data.role === "ROLE_SUPERADMIN") {
                            this.context.router.history.push('/SuperAdmin')
                        } else if (data.role === "ROLE_PARENT") {
                            this.context.router.history.push('/Parent')
                        } else if (data.role === "ROLE_CATERER") {
                            sessionStorage.setItem('catererId', data.catererId);
                            sessionStorage.setItem('countryCode', data.countryCode);
                            sessionStorage.setItem('pageSize', JSON.stringify(data.pageSize || {}));
                            const _schools = {};
                            (data.schools || []).map(school => {
                                _schools[school.schoolId] = data.gradesMap;
                            });
                            sessionStorage.setItem('gradesMap', JSON.stringify(_schools))
                            this.props.history.replace('/caterer');
                        } else if (data.role === "ROLE_DISTRICT") {
                            sessionStorage.setItem('districtId', data.districtId);
                            this.props.history.replace('/district');
                        }
                    }).catch(
                        (error) => {
                            _addNotificationError('Invalid User ID or password.', this)
                            console.log(' response', error)
                        })
                }
            }
            else if (splitArray.length === 2) {//School Admin

                get('/mealSchools/search/findBySubdomain?subdomain=' + splitArray[0] + '&access_token=').then((response) => {
                    if (!response.ok) {
                        throw Error(response.statusText);
                    }
                    console.log('response', response);
                    return response.json();
                }).then(data => {
                    console.log('schoolsubdomaindata', data);
                    let isPaymentEnable = data.isPaymentEnabled || false;
                    let pri_users = _.filter(data.schoolUsers, function (itm) { return itm.isPrimaryUser === true && (itm.username || '').toLowerCase() == (uname || '').toLowerCase() });
                    let isPrimaryAdmin = (pri_users.length > 0) === true ? true : false;
                    let stripeAccountId = data.stripeAccountId;
                    let stripeAcceptance = data.stripeAcceptance;


                    if (data !== null || data !== '') {
                        let schoolId = data._links.self.href.split("/").pop();
                        get('/login/' + schoolId + '?loginModule=' + this.getRoleByUrl() + '&currentDate=' + moment().format('YYYY-MM-DD') + '&access_token=').then((response) => {
                            if (!response.ok) {
                                throw Error(response.statusText);
                            }
                            return response.json();
                        }).then(data => {
                            sessionStorage.setItem('SchoolId', schoolId);
                            sessionStorage.setItem('ROLE', data.role)
                            sessionStorage.setItem('loggedInUserInfo', JSON.stringify(data));
                            sessionStorage.setItem('loggedUserName', data.username);
                            sessionStorage.setItem('schoolName', data.schoolName);
                            sessionStorage.setItem('username', data.username);
                            sessionStorage.setItem('currency_symbol', data.currencySymbol);
                            sessionStorage.setItem('date_format', data.dateFormat);
                            sessionStorage.setItem('countryCode', data.countryCode);
                            sessionStorage.setItem('pageSize', JSON.stringify(data.pageSize || {}));
                            sessionStorage.setItem('date_format', data.dateFormat);
                            sessionStorage.setItem('ISD_code', data.isdCode);
                            sessionStorage.setItem('phoneValidation', data.phoneValidation || 10);
                            sessionStorage.setItem('donationStatus', data.acceptMealDonation)
                            sessionStorage.setItem('spendingLimit', data.dailySpendingLimit)
                            loggedUserInfo.user = data;
                            console.log('logInfo', loggedUserInfo);
                            this.props.setUserInfo(loggedUserInfo);
                            if (data.role === "ROLE_ADMIN") {
                                let sessionUserInfoData = JSON.parse(sessionStorage.getItem('loggedInUserInfo'))
                                sessionUserInfoData.isPaymentEnable = isPaymentEnable;
                                sessionUserInfoData.isPrimaryAdmin = isPrimaryAdmin;
                                sessionUserInfoData.stripeAccountId = stripeAccountId;
                                sessionUserInfoData.stripeAcceptance = stripeAcceptance;
                                sessionStorage.setItem('loggedInUserInfo', JSON.stringify(sessionUserInfoData));
                                sessionStorage.setItem('schoolYearValue', data.schoolYear)
                                sessionStorage.setItem('activeMonth', data.latestActiveMonth)
                                this.context.router.history.push('/schoolAdmin')
                            }
                            else {
                                _addNotificationError('Invalid UserId or Password.', this)
                                console.log('Incorrect role', data.role)
                            }
                        }).catch(
                            (error) => {
                                _addNotificationError('Invalid Sub Domain Please Check the URL.', this)
                                console.log(' response', error)
                            }
                        )

                    }
                    else {
                        this.context.router.history.push('/404')
                    }
                }).catch(
                    (error) => {
                        _addNotificationError('Invalid Sub Domain Please Check the URL.', this)
                        console.log('Incorrect Subdomain', error)
                    }
                )
            } else {
                this.context.router.history.push('/404');
            }
        }).catch(
            (error) => {
                _addNotificationError('Invalid UserId or Password.', this);
            }
        );
        event.preventDefault();
    }

    render() {
        return (
            <div>
                <NotificationSystem ref="notificationSystem" />
                <div className='sweet-loading' style={{ position: 'fixed', top: '50%', left: '48%', zIndex: '1000   ' }}>
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                        loading={this.state.loading}
                    />
                </div>
                {/* <AppHeader/> */}
                <div>
                    <section className="mainContent full-width clearfix" style={{ padding: '0px' }}>
                        <div className='row' style={{ overflowY: 'scroll', overflowX: 'hidden', height: 'calc(100vh - 70px)' }}>
                            <div className='col-lg-7 col-md-6 col-sm-12 loginBackground'>
                            </div>
                            <div className='col-lg-5 col-md-6 col-sm-12'>
                                <div className='row'>
                                    <div className='col-lg-10 col-lg-offset-1 col-md-10 col-md-offset-1 col-sm-10 col-sm-offset-1'>
                                        <Logo />
                                        <div className="panel panel-default formPanel">
                                            <div className="panel-heading border-color-1" style={{
                                                backgroundColor: '#ea7066'
                                            }}>
                                                <h3 className="panel-title">Admin Login</h3>
                                            </div>
                                            <div className="panel-body">
                                                <form
                                                    className="login-form ng-dirty ng-valid-parse ng-valid ng-valid-required"
                                                    onSubmit={this.onSignInClick.bind(this)}>
                                                    <div className="form-group formField">
                                                        <input
                                                            className="form-control ng-not-empty ng-dirty ng-valid-parse ng-valid ng-valid-required ng-touched"
                                                            name="user-id" type="email" placeholder="Email"
                                                            value={this.state.userName}
                                                            onChange={this.handleUserNameChanged.bind(this)} required />
                                                    </div>
                                                    <div className="form-group formField">
                                                        <input
                                                            className="form-control ng-not-empty ng-dirty ng-valid-parse ng-valid ng-valid-required ng-touched"
                                                            name="user-pwd" type="password" placeholder="Password"
                                                            value={this.state.password}
                                                            onChange={this.handlePasswordChanged.bind(this)} required />

                                                    </div>
                                                    <div className="form-group formField">
                                                        <label>
                                                            <input type="checkbox" name="remember"
                                                                checked={this.isCookie || this.state.isCookie.bind}
                                                                onChange={this.setCookie.bind(this)} /> <span
                                                                    className="label-text">Remember Me</span>
                                                        </label>

                                                    </div>
                                                    <div className="form-group formField">
                                                        <button type="submit" id="login" name="signin_btn"
                                                            style={{ marginLeft: '0px' }}
                                                            className="btn btn-primary btn-block bg-color-3 border-color-3">Log
                                                            In
                                                        </button>

                                                    </div>
                                                    <div className="form-group formField">
                                                        <p className="text-right"><Link to="/forgotPassword">Forgot
                                                            password?</Link></p>
                                                    </div>
                                                    <span id="isActive"></span>
                                                </form>
                                            </div>
                                        </div>
                                        {
                                            this.state.isSuperAdmin &&
                                            <div className="panel panel-default formPanel">
                                                <div className="panel-heading border-color-1" style={{
                                                    backgroundColor: '#ea7066'
                                                }}>
                                                    <h3 style={{ textTransform: "none" }} className="panel-title">Are you a
                                                        parent?</h3>
                                                </div>
                                                <div className="panel-body">
                                                    <form
                                                        className="login-form ng-dirty ng-valid-parse ng-valid ng-valid-required"
                                                        onSubmit={this.selfRegParent}>
                                                        <div className="form-group formField">
                                                            <input
                                                                className="form-control ng-not-empty ng-dirty ng-valid-parse ng-valid ng-valid-required ng-touched"
                                                                name="parent-id" type="email" placeholder="Email"
                                                                value={this.state.parentEmail}
                                                                onChange={this.handleParentEmailChanged.bind(this)}
                                                                required />
                                                            <span
                                                                className={this.state.isParentError ? 'has-error' : 'has-success'}>
                                                                {this.state.parentRegMsg}
                                                            </span>
                                                        </div>

                                                        <div className="form-group formField">
                                                            <button type="submit" id="btnParentSubmit"
                                                                name="btnParentSubmit"
                                                                style={{ marginLeft: '0px' }}
                                                                className="btn btn-primary btn-block bg-color-3 border-color-3">Get
                                                                access link
                                                            </button>
                                                        </div>

                                                    </form>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        );
    }
}

Login.contextTypes = {
    router: PropTypes.object.isRequired
}

export default Login;



// WEBPACK FOOTER //
// ./src/components/Auth/Login.jsx